import React, { useState } from 'react';
import LoginModal from './LoginModal.jsx';
import './Header.css';

const Header = ({ isMenuOpen, onMenuToggle, onGlitter, user, onLogin, onLogout, onSignUp }) => {
  const [showLoginModal, setShowLoginModal] = useState(false);

  const handleClick = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    onGlitter({
      x: rect.left + rect.width / 2,
      y: rect.top + rect.height / 2
    });
    setTimeout(() => onGlitter(null), 100);
    onMenuToggle();
  };

  const handleLoginClick = () => {
    setShowLoginModal(true);
  };

  const handleLoginSuccess = (userData) => {
    setShowLoginModal(false);
    onLogin(userData);
  };

  const handleSignUpClick = () => {
    setShowLoginModal(false);
    onSignUp();
  };

  return (
    <>
      <header className="header">
        <button 
          className={`hamburger-menu ${isMenuOpen ? 'active' : ''}`}
          onClick={handleClick}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <div className="header-title">
          <h1>Portal Escolar SIA</h1>
        </div>
        <div className="header-actions">
          {user ? (
            <div className="header-user">
              <span className="user-info">Bem-vindo, {user.username}</span>
              <button 
                className="logout-button"
                onClick={onLogout}
                aria-label="Logout"
              >
                Sair
              </button>
            </div>
          ) : (
            <div className="auth-buttons">
              <button 
                className="signin-button"
                onClick={handleLoginClick}
                aria-label="Sign In"
              >
                Entrar
              </button>
              <button 
                className="signup-button"
                onClick={handleSignUpClick}
                aria-label="Sign Up"
              >
                Criar Conta
              </button>
            </div>
          )}
        </div>
      </header>
      {showLoginModal && (
        <LoginModal 
          onClose={() => setShowLoginModal(false)}
          onLogin={handleLoginSuccess}
          onRegister={handleSignUpClick}
        />
      )}
    </>
  );
};

export default Header;
